var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20923_108993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 24C19.2993 24 24.6719 18.6274 24.6719 12C24.6719 5.37258 19.2993 0 12.6719 0C6.04446 0 0.671875 5.37258 0.671875 12C0.671875 18.6274 6.04446 24 12.6719 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6718 0.166672V10.0969H24.5213C23.6093 4.37389 18.6515 0 12.6718 0C11.9903 0 11.3222 0.0573039 10.6718 0.166672Z",
    fill: "#006AA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67178 1.60566C3.60807 3.37797 1.40087 6.46582 0.822266 10.0969H6.67178V1.60566Z",
    fill: "#006AA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.854768 14.0969C1.47986 17.6439 3.66271 20.6536 6.67178 22.3943V14.0969H0.854768Z",
    fill: "#006AA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6718 23.8333C11.3222 23.9427 11.9903 24 12.6719 24C18.5839 24 23.4971 19.7245 24.4889 14.0969H10.6718V23.8333Z",
    fill: "#006AA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20923_108993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.671875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.5f56b285b31055b8c3078c6cc84b78f7.svg";
export { ForwardRef as ReactComponent };